<div
  stchPopover
  [stchPopoverArrow]="true"
  [stchPopoverContent]="popoverTemplate"
  [stchPopoverInnerShadow]="true"
  stchPopoverPlacement="right"
  [stchPopoverDisabled]="!minimized"
  stchPopoverTrigger="click"
  >
  <app-sidebar-item
    [title]="title"
    icon="sapphire-project"
    class="rounded hover:bg-hover"
    [depth]="depth ?? 0"
    [expandable]="true"
    [expanded]="expanded | lsValue : application : team?.id"
    [minimized]="minimized"
    [active]="currentTeamId === team?.id && sidebarFilter === 'all_projects'"
    [actions]="rail ? [] : [{
      icon: 'sapphire-plus',
      tooltip: 'Add new project',
      template: projectQuickFormTemplate,
      guardChildren: true,
      until: quickFormPopoverClose,
      appearance: 'dialog'
    }]"
    (onExpand)="expanded.set($event, application, team?.id)"

    (appClick)="selectFilter.emit('all_projects')"
    appSidebarContextMenu="all_projects"
    [appSidebarContextMenuTenantId]="tenantId"
    [appSidebarContextMenuRail]="rail"
    [appSidebarContextMenuRailScope]="railScope"
    >
    @if (rail) {
      <!--
        Rail sections only: the plus and the options menu as real buttons, so a keyboard reaches them. They show
        on hover and on focus, like the row's other controls. The options button opens the very menu a right-click
        on the header does.
      -->
      <button
        type="button"
        class="inline-flex border-0 bg-transparent p-0 opacity-0 group-hover:opacity-100 focus-visible:opacity-100"
        [attr.aria-label]="'New Project in ' + railWorkspace + ' Workspace'"
        [attr.title]="'New Project in ' + railWorkspace + ' Workspace'"
        stchPopover
        [stchPopoverArrow]="true"
        [stchPopoverContent]="projectQuickFormTemplate"
        [stchPopoverGuardChildren]="true"
        stchPopoverAppearance="dialog"
        stchPopoverPlacement="right"
        stchPopoverTrigger="click"
        [stchPopoverShowUntil]="quickFormPopoverClose"
        (click)="$event.stopPropagation()"
      >
        <app-icon name="sapphire-plus" />
      </button>
      <button
        type="button"
        class="inline-flex border-0 bg-transparent p-0 opacity-0 group-hover:opacity-100 focus-visible:opacity-100"
        [attr.aria-label]="railWorkspace + ' Projects options'"
        [attr.title]="railWorkspace + ' Projects options'"
        aria-haspopup="menu"
        appSidebarContextMenu="all_projects"
        [appSidebarContextMenuTenantId]="tenantId"
        [appSidebarContextMenuRail]="true"
        [appSidebarContextMenuRailScope]="railScope"
        stchPopoverTrigger="click"
        stchPopoverPlacement="bottomLeft"
        (click)="$event.stopPropagation()"
      >
        <app-icon name="sapphire-ellipsis" />
      </button>
    }
    <app-context-menu-state-indicator
      appearance="sapphire"
      svgIcon="sapphire-ellipsis"
      appProjectsListContextMenu
      [appProjectsListContextMenuWithSidebarFilters]="true"
      />
    </app-sidebar-item>
  </div>

  @if (!minimized) {
    <div
      class="collapseable-body"
      [@heightAnimation]="(expanded | lsValue : application : team?.id) ? 'show' : 'hide'"
      >
      <ng-container *ngTemplateOutlet="contentTemplate" />
    </div>
  }

  <ng-template #popoverTemplate>
    @if (minimized) {
      <div
        class="popover-body"
        >
        <ng-container *ngTemplateOutlet="contentTemplate" />
      </div>
    }
  </ng-template>

  <ng-template #contentTemplate>
    <app-side-bar-projects-tree
      [filters]="filters"
      [team]="team"
      [tenantId]="tenantId"
      [itemCreateFormTemplate]="projectQuickFormTemplate"
    />
  </ng-template>

  <ng-template #projectQuickFormTemplate let-parentId="parentId">
    <div class="quick-form-container">
      <app-project-quick-form
        #quickForm
        [project]="quickProject"
        [autofocus]="true"
        [parentId]="parentId"
        [inline]="true"
        [showMore]="true"
        [showCancel]="true"
        (save)="createProject($event, quickForm)"
        (close)="quickFormPopoverClose.next()"
        (more)="handleMore($event)"
        />
      </div>
    </ng-template>
